module.exports = __webpack_public_path__ + "img/d3.72ff7d91.jpg";